import { Text, Title } from "@clipboard-health/ui-components";

import { MarketplaceIntroSlideLayout } from "./MarketplaceIntroSlideLayout";

interface CrossMarketplaceIntroSlideProps {
  unfamiliarMarketplace: "shifts" | "jobs";
}

export function CrossMarketplaceIntroSlide(props: CrossMarketplaceIntroSlideProps) {
  const { unfamiliarMarketplace } = props;

  const familiarMarketplace = unfamiliarMarketplace === "shifts" ? "jobs" : "shifts";

  return (
    <MarketplaceIntroSlideLayout>
      <Title variant="h3" component="h1" sx={{ textAlign: "center", margin: 0 }}>
        Interested in {unfamiliarMarketplace}?
      </Title>

      <Text variant="body1">
        {unfamiliarMarketplace === "shifts" ? "Shifts" : "Jobs"} work a little differently from{" "}
        {familiarMarketplace === "shifts" ? "shifts" : "jobs"}!
      </Text>
    </MarketplaceIntroSlideLayout>
  );
}
